import type { FC } from 'react';
import { useState } from 'react';
import BottomSheet from '../BottomSheet';
import * as S from './styles';
import { ChevronDownIcon } from '../../../assets/icons/ChevronDownIcon';
export interface SelectOption {
  value: string;
  label: string;
}

interface MobileSelectProps {
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  title?: string;
  showSelectedValue?: boolean;
  /** Form-field treatment: the field name stays visible above the chosen value once one is picked. */
  floatingLabel?: boolean;
}

export const MobileSelect: FC<MobileSelectProps> = ({
  options,
  value,
  onChange,
  title = 'Sort',
  showSelectedValue = false,
  floatingLabel = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedOption = options.find((option) => option.value === value);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const handleSelect = (newValue: string) => {
    onChange(newValue);
    handleClose();
  };

  return (
    <>
      <S.SelectButton onClick={handleOpen} isTall={floatingLabel && Boolean(selectedOption)}>
        {floatingLabel && selectedOption ? (
          <span className="flex flex-col items-start gap-0.5 text-left">
            <span className="text-label-xsmall font-normal text-neutral-400 leading-none">{title}</span>
            <span className="text-paragraph-small text-neutral-700 leading-none line-clamp-1">{selectedOption.label}</span>
          </span>
        ) : (
          <span className="line-clamp-1">{showSelectedValue && selectedOption ? selectedOption.label : title}</span>
        )}
        <span>
          <ChevronDownIcon />
        </span>
      </S.SelectButton>

      <BottomSheet isOpen={isOpen} onClose={handleClose} title={title}>
        <S.OptionsList>
          {options.map((option) => (
            <S.OptionItem
              key={option.value}
              isSelected={option.value === value}
              onClick={() => handleSelect(option.value)}
            >
              {option.label}
              {option.value === value && <S.CheckIcon>✓</S.CheckIcon>}
            </S.OptionItem>
          ))}
        </S.OptionsList>
      </BottomSheet>
    </>
  );
};

export default MobileSelect;
